import { useCallback, useContext, useEffect } from 'react';
import { SectionViewedLogger } from '@/vdp/Analytics';
import Section from '~/constants/vdp/section';
import { useScreenSize } from '~/context/common/DeviceContext';
import UiContext from '~/context/vdp/UiContext';
import { useGetHasImages } from '~/context/vdp/VehicleContext';
import useShouldRenderCondensedHero from '~/hooks/vdp/useShouldRenderCondensedHero';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';
import { logError } from '~/utilities/loggers';
import ScrollableGallery from './ScrollableGallery';

export function Gallery() {
  const { setSectionViewed } = useContext(UiContext);
  const hasImages = useGetHasImages();
  const shouldRenderCondensedHero = useShouldRenderCondensedHero();

  const showGallery = !shouldRenderCondensedHero && hasImages;

  const isHeightLessThan610 = useScreenSize().height < 610;
  const viewedThreshold = isHeightLessThan610 ? 0.2 : 0.9;

  const handleSectionViewed = useCallback(() => {
    setSectionViewed(Section.Gallery);
  }, [setSectionViewed]);

  useEffect(() => {
    if (hasImages) return;

    logError('No Gallery Images');
  }, [hasImages]);

  if (!showGallery) return null;

  return (
    <SectionViewedLogger
      callback={handleSectionViewed}
      section={Section.Gallery}
      threshold={viewedThreshold}
    >
      <ScrollableGallery />
    </SectionViewedLogger>
  );
}

export default withErrorBoundary(Gallery, { section: Section.Gallery });
